@if (this.showCard()) {
  <app-small-tuile
    type="icon"
    icon="fa-regular fa-bolt-lightning"
    [title]="'dashboard.puissance' | translate"
    [mode]="getMode()"
  >
  </app-small-tuile>
}
